import { Model } from "@rematch/core";
import { IGooglePlace } from "shared/model/ICoworkGeoLocation";

import { IState } from "..";
import LandbotClient from "../../../components/Landbot/LandbotClient";
import RavenService from "../../../services/Logging/RavenService";
import { Dispatch } from "../../store/store";
import { StateModules } from "../types";
import {
  connectWithLinkedin,
  fetchLocationsAutoComplete
} from "./CommonBotEffects";

let landbotClient: LandbotClient;

export interface ICommonBotModule extends Model {
  name: StateModules;
  state: ICommonBotState;
  reducers: ICommonBotReducers;
  effects: ICommonBotEffects;
}

export type ICommonBotState = {
  triggerMessage?: string;
  loaded: boolean;
  placesQuery: string;
  placesAutocomplete: IGooglePlace[];
  selectedPlace?: IGooglePlace | string;
  connectedWithLinkedin?: boolean;
};

export type ICommonBotReducers = {
  setTriggerMessage: (
    state: ICommonBotState,
    params: { msg: string }
  ) => ICommonBotState;

  clearTriggerMessage: (state: ICommonBotState, params: {}) => ICommonBotState;
  setBotLoaded: (state: ICommonBotState, params: {}) => ICommonBotState;

  setPlacesSearchQuery: (
    state: ICommonBotState,
    params: { query: string }
  ) => ICommonBotState;
  setPlacesAutocomplete: (
    state: ICommonBotState,
    params: { places: IGooglePlace[] }
  ) => ICommonBotState;

  setSelectedPlace: (
    state: ICommonBotState,
    params: { place: IGooglePlace | string | undefined }
  ) => ICommonBotState;

  setConnectedWithLinkedin: (
    state: ICommonBotState,
    params: { connected: boolean }
  ) => ICommonBotState;
};

export type ICommonBotEffects = {
  sendMessage: (params: { msg: string }, state: IState) => void;
  onBotLoaded: (params: { client: LandbotClient }, state: IState) => void;

  fetchLocationsAutoComplete: (
    params: { query: string , generalSearch? : boolean},
    state: IState
  ) => void;
  connectWithLinkedin: (params: {}, state: IState) => void;
};

export type ICommonBotDispatch = {
  setTriggerMessage: (params: { msg: string }) => void;
  clearTriggerMessage: () => void;
  setBotLoaded: () => void;
  setPlacesSearchQuery: (params: { query: string }) => void;
  setPlacesAutocomplete: (params: { places: IGooglePlace[] }) => void;
  setSelectedPlace: (params: {
    place: IGooglePlace | string | undefined;
  }) => void;
  setConnectedWithLinkedin: (params: { connected: boolean }) => void;

  sendMessage: (params: { msg: string }) => void;
  onBotLoaded: (params: { client: LandbotClient }) => void;
  fetchLocationsAutoComplete: (params: { query: string, generalSearch? : boolean }) => void;
  connectWithLinkedin: () => void;
};

export const CommonBotModule: ICommonBotModule = {
  name: "commonBot",
  state: { loaded: false, placesQuery: "", placesAutocomplete: [] },
  reducers: {
    setTriggerMessage: (
      state: ICommonBotState,
      params: { msg: string }
    ): ICommonBotState => ({
      ...state,
      triggerMessage: params.msg
    }),
    clearTriggerMessage: (
      state: ICommonBotState,
      params: {}
    ): ICommonBotState => ({
      ...state,
      triggerMessage: undefined
    }),
    setBotLoaded: (state: ICommonBotState, params: {}): ICommonBotState => ({
      ...state,
      loaded: true
    }),
    setPlacesSearchQuery: (
      state: ICommonBotState,
      params: { query: string }
    ): ICommonBotState => ({
      ...state,
      placesQuery: params.query
    }),
    setPlacesAutocomplete: (
      state: ICommonBotState,
      params: { places: IGooglePlace[] }
    ): ICommonBotState => ({
      ...state,
      placesAutocomplete: params.places
    }),
    setSelectedPlace: (
      state: ICommonBotState,
      params: { place: IGooglePlace | string }
    ): ICommonBotState => ({
      ...state,
      selectedPlace: params.place
    }),
    setConnectedWithLinkedin: (
      state: ICommonBotState,
      params: { connected: boolean }
    ): ICommonBotState => ({
      ...state,
      connectedWithLinkedin: params.connected
    })
  },
  effects: {
    sendMessage: (params: { msg: string }, state: IState) => {
      Dispatch.commonBot.clearTriggerMessage();
      if (landbotClient) {
        landbotClient.send(params.msg);
      } else {
        const msg = `Failed sending landbot message - No client. ${params.msg}`;
        console.error(msg);
        RavenService.captureMessage(msg);
      }
    },
    onBotLoaded: (params: { client: LandbotClient }, state: IState) => {
      landbotClient = params.client;
      Dispatch.commonBot.setBotLoaded();
    },
    fetchLocationsAutoComplete,
    connectWithLinkedin
  }
};



// WEBPACK FOOTER //
// ./src/state/modules/commonBot/CommonBotModule.ts